import { gql } from '@apollo/client';

export const CREATE_COMPANY_INVITE = gql`
  mutation CreateCompanyInvitesWithLink($inviteLink: String!) {
    createCompanyInvitesWithLink(inviteLink: $inviteLink) {
      void
    }
  }
`;

export const GET_COMPANY_BY_LINK = gql`
  query CompanyByInviteLink($inviteLink: String!) {
    companyByInviteLink(inviteLink: $inviteLink) {
      id
      name
    }
  }
`;
